document.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll(".lcf-wrapper");

  forms.forEach((formWrapper) => {
    const phoneInput = formWrapper.querySelector(".lcf-input-phone");
    const textarea = formWrapper.querySelector(".lcf-textarea");
    const counter = formWrapper.querySelector(".lcf-textarea-counter");

    if (phoneInput && window.intlTelInput) {
      const marketCountry = phoneInput.dataset.countryCode || "ua";

      window.intlTelInput(phoneInput, {
        initialCountry: marketCountry,
        separateDialCode: true,
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.4/build/js/utils.js",
        customPlaceholder: function(selectedCountryPlaceholder) {
          if (!selectedCountryPlaceholder) return "";
          return selectedCountryPlaceholder.replace(/\d/g, '0');
        }
      });
    }

    if (textarea && counter) {
      textarea.addEventListener("input", () => {
        const currentLength = textarea.value.length;
        counter.textContent = `${currentLength} / 500`;
      });
    }
  });

  const anchorLinks = document.querySelectorAll('a[href$="#b2b-form"]');
  anchorLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      const target = document.querySelector("#b2b-form");
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });
});